var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Badge',{attrs:{"count":_vm.images?.leng == 1 ? 0 : _vm.images?.leng}},[_c('el-image',{staticClass:"previewsImage-tag",style:(_vm.imgStyle),attrs:{"src":_vm.thumb,"lazy":_vm.lazy,"preview-src-list":_vm.images,"alt":"图片"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }